<div>
  <div class="search">
    <div class="search-filters-section" layout="row" layout-align="space-between start">
      <form
        class="form-inline rx-hub-resend-orders-search-form"
        layout="row"
        layout-align="start center"
        (ngSubmit)="onSearch()"
      >
        <div class="form-group">
          <div class="relative">
            <input
              class="form-control"
              id="resent-orders-search-field"
              type="text"
              [ngModel]="pagination().search"
              (ngModelChange)="updateSearch($event)"
              name="search"
              placeholder="Columbus ID#, Visit#"
              aria-label="Search by Columbus ID or Visit number"
            />
            @if (pagination().search) {
              <i class="icon-x-circle input-icon--right no-label" (click)="clearSearch()"></i>
            }
          </div>
        </div>
        <div class="form-group">
          <button class="btn btn-success" type="submit">Search <i class="icon-mag"></i></button>
        </div>
      </form>
    </div>
  </div>

  @if (orders().length) {
    <div class="order-table-container">
      <!-- Pagination top -->
      <nav class="table-footer" aria-label="Table pagination top">
        <div class="table-footer__pagination">
          <button class="btn btn-default btn-sm" [disabled]="!hasPreviousPage()" (click)="goPrevious()">
            <i class="ion ion-chevron-left"></i>
          </button>
          <select
            class="form-control input-sm rows-per-page"
            [ngModel]="currentPage()"
            name="currentPageTop"
            (ngModelChange)="onPageChange($event)"
            aria-label="Current page"
          >
            @for (page of pages(); track page) {
              <option [ngValue]="page">{{ page }}</option>
            }
          </select>
          <button class="btn btn-default btn-sm" [disabled]="!hasNextPage()" (click)="goNext()">
            <i class="ion ion-chevron-right"></i>
          </button>
        </div>
        <div class="table-footer__rows-per-page">
          <label class="m-r-xs">Rows Per Page</label>
          <select
            class="form-control input-sm rows-per-page"
            [ngModel]="pagination().limit"
            name="limitTop"
            (ngModelChange)="onLimitChange($event)"
          >
            @for (option of itemsPerPageOptions; track option) {
              <option [ngValue]="option">{{ option }}</option>
            }
          </select>
        </div>
      </nav>

      <!-- Table -->
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="text-center">Columbus ID</th>
            <th class="text-center sortable" (click)="onSortChange('dispense_order_id')">
              Dispense Order
              @if (pagination().sort === 'dispense_order_id') {
                <i class="ion" [class.ion-arrow-up-b]="pagination().order === 'asc'" [class.ion-arrow-down-b]="pagination().order === 'desc'"></i>
              }
            </th>
            <th class="text-center">Original</th>
            <th class="text-center">Repeat</th>
            <th class="text-center sortable" (click)="onSortChange('order_id')">
              Visit
              @if (pagination().sort === 'order_id') {
                <i class="ion" [class.ion-arrow-up-b]="pagination().order === 'asc'" [class.ion-arrow-down-b]="pagination().order === 'desc'"></i>
              }
            </th>
            <th class="text-center">Pharmacy</th>
            <th class="text-center">Status</th>
            <th class="text-center">Legal Doc Sent</th>
            <th class="text-center">Legal Doc Received</th>
            <th class="text-center">o2d Sent</th>
            <th class="text-center">o2d Received</th>
            <th class="text-center">o2d Last Status</th>
            <th class="text-center"></th>
          </tr>
        </thead>

        @if (isLoading()) {
          <tbody>
            <tr>
              <td colspan="13" class="text-center">Loading...</td>
            </tr>
          </tbody>
        } @else {
          <tbody>
            @for (order of orders(); track order.id) {
              <tr>
                <td class="text-center">
                  @if (order.external_order_number) {
                    <span>{{ order.external_order_number }}</span>
                  }
                </td>
                <td class="text-center"><span>{{ order.id }}</span></td>
                <td class="text-center"><span>{{ order.original_dispense_order_id }}</span></td>
                <td class="text-center"><span>{{ order.repeat_number }}</span></td>
                <td class="text-center"><span>{{ order.order_id }}</span></td>
                <td class="text-center"><span>{{ order.pharmacy_id }}</span></td>
                <td class="text-center"><span>{{ order.status }}</span></td>
                <td class="text-center">
                  @if (order.legal_doc_sent) {
                    <span>{{ order.legal_doc_sent * 1000 | date: 'dd/MMM/yyyy hh:mm a' }}</span>
                  }
                </td>
                <td class="text-center">
                  @if (order.legal_doc_received) {
                    <span>{{ order.legal_doc_received * 1000 | date: 'dd/MMM/yyyy hh:mm a' }}</span>
                  }
                  @if (order.legal_doc_received === 0) {
                    <span>-</span>
                  }
                </td>
                <td class="text-center">
                  @if (order.o2d_sent) {
                    <span>{{ order.o2d_sent * 1000 | date: 'dd/MMM/yyyy hh:mm a' }}</span>
                  }
                </td>
                <td class="text-center">
                  @if (order.o2d_received) {
                    <span>{{ order.o2d_received * 1000 | date: 'dd/MMM/yyyy hh:mm a' }}</span>
                  }
                  @if (order.o2d_received === 0) {
                    <span>-</span>
                  }
                </td>
                <td class="text-center"><span>{{ order.o2d_last_status }}</span></td>
                <td class="text-center">
                  <button
                    class="btn btn-resend"
                    (click)="resendOrder(order)"
                    [disabled]="httpRequestInProgress()"
                  >
                    Resend
                  </button>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>

      <!-- Pagination bottom -->
      <nav class="table-footer" aria-label="Table pagination bottom">
        <div class="table-footer__pagination">
          <button class="btn btn-default btn-sm" [disabled]="!hasPreviousPage()" (click)="goPrevious()">
            <i class="ion ion-chevron-left"></i>
          </button>
          <select
            class="form-control input-sm rows-per-page"
            [ngModel]="currentPage()"
            name="currentPageBottom"
            (ngModelChange)="onPageChange($event)"
            aria-label="Current page"
          >
            @for (page of pages(); track page) {
              <option [ngValue]="page">{{ page }}</option>
            }
          </select>
          <button class="btn btn-default btn-sm" [disabled]="!hasNextPage()" (click)="goNext()">
            <i class="ion ion-chevron-right"></i>
          </button>
        </div>
        <div class="table-footer__rows-per-page">
          <label class="m-r-xs">Rows Per Page</label>
          <select
            class="form-control input-sm rows-per-page"
            [ngModel]="pagination().limit"
            name="limitBottom"
            (ngModelChange)="onLimitChange($event)"
          >
            @for (option of itemsPerPageOptions; track option) {
              <option [ngValue]="option">{{ option }}</option>
            }
          </select>
        </div>
      </nav>
    </div>
  }

  @if (!orders().length && !isLoading()) {
    <div class="text-center">
      <h4 class="subheader" style="margin-top: 30px; font-size: 14px;">Did not find any visits</h4>
    </div>
  }
</div>
